import axios from 'axios';
import env from '../../environment';
import { HANDOFF_API_PATH } from './handoffConstants';

const baseUrl = () => `${env.themisIntake.url}${HANDOFF_API_PATH}`;

/** Exchange the opaque launch token for a handoff session scoped to one operation. */
export const redeemLaunchToken = async (launchToken) => {
	const response = await axios.post(`${baseUrl()}/launch-token/redeem`, { launchToken });

	return response.data;
};

/** Read the operation status once (called repeatedly by the polling loop). */
export const getOperationStatus = async (operationId, sessionToken) => {
	const response = await axios.get(`${baseUrl()}/operations/${operationId}/status`, {
		headers: { Authorization: `Bearer ${sessionToken}` }
	});

	return response.data;
};
